function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1310",
  "data-name": "Group 1310",
  transform: "translate(0.75 0.75)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_482",
  "data-name": "Path 482",
  d: "M310.218-275.893a5.2,5.2,0,0,0-5.2-5.2,5.2,5.2,0,0,0-5.2,5.2v2.863a5.2,5.2,0,0,0,5.2,5.2,5.2,5.2,0,0,0,5.2-5.2Z",
  transform: "translate(-295.021 281.09)",
  fill: "none",
  stroke: "#e94e4e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_483",
  "data-name": "Path 483",
  d: "M289.5-241.916l-3.366,1.359a1.29,1.29,0,0,0-.807,1.2v2.257a1.463,1.463,0,0,0,1.463,1.463h17.074a1.463,1.463,0,0,0,1.463-1.463v-2.257a1.29,1.29,0,0,0-.807-1.2l-3.366-1.359",
  transform: "translate(-285.324 254.892)",
  fill: "none",
  stroke: "#e94e4e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}));

var SvgImpersonation = function SvgImpersonation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.5,
    height: 20.752,
    viewBox: "0 0 21.5 20.752",
    preserveAspectRatio: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImpersonation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/impersonation.37d4fe9c.svg";
export { ForwardRef as ReactComponent };